import { CLIENT_ENV } from "kreate-env/client";

const POPUP_WIDTH = 640; // px
const POPUP_HEIGHT = 480; // px

export function openLinkInPopup(url: string) {
  window.open(
    url,
    "_blank",
    [
      "popup",
      `width=${POPUP_WIDTH}`,
      `height=${POPUP_HEIGHT}`,
      `left=${Math.trunc((window.screen.width - POPUP_WIDTH) / 2)}`,
      `top=${Math.trunc((window.screen.height - POPUP_HEIGHT) / 2)}`,
      "noreferrer",
    ].join(",")
  );
}

export function shareOnTwitter(url: string, description?: string) {
  if (url.startsWith("/")) {
    url = CLIENT_ENV.KREATE_ORIGIN + url;
  }
  // ends with a new line so that user can type their text immediately,
  // without accidentally changing the URL
  const text = description ? [description, "", url, ""].join("\n") : url + "\n";
  openLinkInPopup(
    "https://twitter.com/intent/tweet?" +
      new URLSearchParams({ text }).toString()
  );
}

export function shareOnFacebook(url: string) {
  if (url.startsWith("/")) {
    url = CLIENT_ENV.KREATE_ORIGIN + url;
  }
  // Facebook only allows to share a link, without prefilled text
  openLinkInPopup(
    "https://www.facebook.com/sharer/sharer.php?" +
      new URLSearchParams({ u: url }).toString()
  );
}

export function copyUrlToClipboard(url: string) {
  if (url.startsWith("/")) {
    url = CLIENT_ENV.KREATE_ORIGIN + url;
  }
  void navigator.clipboard.writeText(url);
}
